import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Fullstacktemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to Full Stack Development",
        content: [
          "Overview of Full Stack Development",
          "Understanding the client-server architecture",
          "Introduction to front-end, back-end, and database development",
          "Web development frameworks and tools",
          "Agile development methodologies"
        ]
      },
      {
        title: "Web Development Basics",
        content: [
          "HTML, CSS, and JavaScript basics",
          "Creating static web pages",
          "Responsive web design",
          "Web development best practices",
          "Debugging tools and techniques"
        ]
      },
      {
        title: "Front-End Development",
        content: [
          "Introduction to front-end development",
          "React or Angular framework",
          "State management with Redux or NgRx",
          "UI components and libraries",
          "Unit testing and end-to-end testing"
        ]
      },
      {
        title: "Back-End Development",
        content: [
          "Introduction to back-end development",
          "Node.js or Python",
          "Web API development",
          "Authentication and authorization",
          "Database integration"
        ]
      },
      {
        title: "Database Development",
        content: [
          "Introduction to databases",
          "Relational database concepts",
          "SQL basics",
          "Data modeling",
          "NoSQL databases"
        ]
      },
      {
        title: "Full Stack Project Development",
        content: [
          "Project planning and requirements gathering",
          "Building a full stack application from scratch",
          "Version control with Git",
          "Deploying a full stack application",
          "Project management and collaboration tools"
        ]
      },
      {
        title: "Web Security",
        content: [
          "Web application security threats",
          "Authentication and authorization",
          "Encryption and secure communications",
          "Security best practices",
          "Penetration testing"
        ]
      },
      {
        title: "DevOps and Continuous Integration/Continuous Deployment (CI/CD)",
        content: [
          "Introduction to DevOps",
          "CI/CD pipeline setup and configuration",
          "Building, testing, and deploying applications",
          "Containerization and orchestration with Docker and Kubernetes",
          "Monitoring and logging"
        ]
      },
      {
        title: "Cloud Computing",
        content: [
          "Introduction to cloud computing",
          "Cloud computing models and service providers",
          "Cloud deployment models",
          "Cloud security and compliance",
          "Cloud cost management"
        ]
      },
      {
        title: "Mobile Development",
        content: [
          "Introduction to mobile development",
          "iOS or Android development",
          "Mobile UI and user experience",
          "Mobile data management",
          "Mobile app deployment"
        ]
      },
    ]

    const faqData = [
      {
        question: 'What is Full Stack Developer Training?',
        answer:
          'Full Stack Developer Training is a comprehensive program designed to equip individuals with the skills and knowledge required to develop both the front-end and back-end components of web applications',
      },
      {
        question: 'Why is Full Stack Developer Training important?',
        answer:
          'Full Stack Developer Training is essential for individuals aspiring to become proficient in all aspects of web development, enabling them to build dynamic and interactive web applications from start to finish',
      },
      {
        question: 'Are there any prerequisites for enrolling in Full Stack Developer Training?',
        answer:
          'While some basic knowledge of programming concepts can be beneficial, there are no strict prerequisites for enrolling in Full Stack Developer Training at the best training centre. Our courses cater to learners with varying levels of experience'
        
        },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'Full stack developers can pursue a variety of career opportunities such as Full Stack Developer, Web Developer, Software Engineer, Solutions Architect, and Technical Lead.'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into Full Stack Development at the Best Training Centre. Our comprehensive Full Stack Developer training program welcomes learners from diverse backgrounds, regardless of prior experience. Whether you're a seasoned programmer or a newcomer to the world of coding, our courses cater to individuals at every skill level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential Full Stack Development concepts, including front-end and back-end technologies, databases, server management, and more. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in the dynamic field of Full Stack Development. Join us and unlock your Full Stack Developer potential with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
    
     return(
      <>
       
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Full stack development encompasses end-to-end application software development, which means taking charge of both the front end and the back end of a web application. A full stack web developer is a versatile professional who possesses the capability to create and manage both client-side and server-side software."/> */}
          <NewMainsec rating='4.9' students={"789"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="A frontend developer, a specialized type of web developer, plays a crucial role in shaping the visual and interactive aspects of a website or web application. Their primary responsibility revolves around crafting the user interface (UI) and user experience (UX) components, ensuring that the site not only looks aesthetically pleasing but also functions seamlessly." />

          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Are you looking to enhance your skills in FullStack Development? If yes, then look no further. FullStack ${this.props.location1} is a highly sought-after field with an increasing demand for professionals with FullStack Development skills. At Learnsoft.org, we offer premium FullStack Training courses in ${this.props.location} to help individuals sharpen their skills and gain a thorough understanding of FullStack Development principles and practices. Our certified trainers utilize a hands-on approach, incorporating real-world case studies and practical exercises to provide a well-rounded education. Whether you're a beginner or looking to upgrade your FullStack Development skills, Learnsoft.org's FullStack ${this.props.location1} is the ideal choice to take your career to the next level. Contact us today to know more about our courses and embark on your FullStack Development journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our FullStack Development course encompasses a broad range of topics, including front-end and back-end development, database management, and cloud infrastructure. Our certified trainers will guide you through hands-on exercises and real-world scenarios to help you comprehend the concepts and techniques used in FullStack Development. By the end of the course, you will be able to implement FullStack Development practices in your own projects."}/>
            </section>
 <Batchtime title={this.props.title} offer="29,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/> 
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou7="Java" coupath7="java" cou6='Python' coupath6='python' cou4='ReactJS' coupath4='reactjs' cou='AngularJS' coupath='angularjs' cou3='Front End Developer' coupath3='front-end-developer'
          cou10='R Programming' coupath10='rprogram' cou9='JavaScript' coupath9='javascript' cou1='VueJS' coupath1='vuejs'
          cou5='TypeScript' coupath5='type-script' cou2='Flutter' coupath2='flutter'  cou8='Go' coupath8='go' />

      </>
    );
  }
}
